var map = {
	"./template.bet777": 1960,
	"./template.bet777.tsx": 1960,
	"./template.betgalaxy": 1961,
	"./template.betgalaxy.tsx": 1961,
	"./template.betprofessor": 1984,
	"./template.betprofessor.tsx": 1984,
	"./template.buffalobet": 1962,
	"./template.buffalobet.tsx": 1962,
	"./template.default": 142,
	"./template.default.tsx": 142,
	"./template.forsport": 1963,
	"./template.forsport.tsx": 1963,
	"./template.gigabet": 1964,
	"./template.gigabet.tsx": 1964,
	"./template.goldenbet888": 1965,
	"./template.goldenbet888.tsx": 1965,
	"./template.goldenrush": 1966,
	"./template.goldenrush.tsx": 1966,
	"./template.juicybet": 1967,
	"./template.juicybet.tsx": 1967,
	"./template.magnumbet": 1968,
	"./template.magnumbet.tsx": 1968,
	"./template.oldgill": 2055,
	"./template.oldgill.tsx": 2055,
	"./template.puntgenie": 1985,
	"./template.puntgenie.tsx": 1985,
	"./template.pyramidbet": 1969,
	"./template.pyramidbet.tsx": 1969,
	"./template.slambet": 1970,
	"./template.slambet.tsx": 1970,
	"./template.sterlingparker": 1971,
	"./template.sterlingparker.tsx": 1971,
	"./template.templebet": 1972,
	"./template.templebet.tsx": 1972,
	"./template.titanbet": 1973,
	"./template.titanbet.tsx": 1973,
	"./template.ts": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2809;